import DOMPurify from 'dompurify';

// The html profile's attribute allowlist keeps href/rel but strips target, and
// Quill's link format always emits rel="noopener noreferrer" target="_blank" —
// so without this, sanitized stored notes would silently start navigating the
// SPA away in the same tab. Allow target back in, then lock it down: only
// target="_blank" survives (anything else is stripped), and rel is forced to
// "noopener noreferrer" whenever target survives, so a crafted target/rel pair
// can't opener-hijack the window. Registered once at module scope — DOMPurify
// hooks are global, so adding this per-call would stack duplicate hooks.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (!node.hasAttribute || !node.hasAttribute('target')) return;

  if (node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  } else {
    node.removeAttribute('target');
  }
});

/** Sanitize stored rich-text HTML (Quill output) before any innerHTML render. */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true }, ADD_ATTR: ['target'] });
}
